import axios from "axios"
import { logout } from "QuorumGrassroots/framework/action-creators"

/**
 * Global axios response interceptor for Grassroots Action Center
 * Handles 401 Unauthorized errors by automatically logging out the user
 */
const handle401Logout = (response) => {
    return response
}

const handle401Error = (error) => {
    if (error && error.response && error.response.status === 401) {
        if (window.store && window.store.dispatch) {
            window.store.dispatch(logout())
        }
    }

    return Promise.reject(error)
}

// Add the response interceptor
axios.interceptors.response.use(handle401Logout, handle401Error)
